import Swal from 'sweetalert2'
import axios from 'axios'

export default function onLocalStorage(selectedDateBorn, gender, marital, religion, province, districts, fullname, email, noWA, zoom, nik, address, kecamatan, kelurahan, postalCode, history, birthPlace, location) {
    let param = [selectedDateBorn, gender, marital, religion, province, districts, fullname, email, noWA, zoom, nik, address, kecamatan, kelurahan, postalCode, birthPlace]
    let paramStr = ['Tanggal Lahir', 'Jenis Kelamin', 'Status Pernikahan', 'Agama', 'Provinsi', 'Kabupaten', 'Nama', 'Email', 'No. WA', 'Zoom User', 'NIK', 'Alamat', 'Kecamatan', 'Kelurahan', 'Kode Pos', 'Tempat Lahir']
    if (nik.length > 16) {
        return Swal.fire({
            icon: 'error',
            title: 'NIK lebih dari 16 karakter'
        })
    }
    if (postalCode.length > 5) {
        return Swal.fire({
            icon: 'error',
            title: 'Kode Pos lebih dari 5 karakter'
        })
    }

    let empty = []
    for (let index = 0; index < param.length; index++) {
        const element = param[index];
        if (!element) {
            empty.push(paramStr[index])
        }
    }

    if (empty.length !== 0) {
        return Swal.fire({
            icon: 'error',
            title: 'Masih belum di isi',
            text: empty.join(' , '),
        })
    }

    axios.post(`${process.env.REACT_APP_API}/participant/id`, {
        email: email,
        first_name: fullname.split(" ", 1)[0],
        last_name: fullname.split(" ").slice(1).join(' '),
        no_wa: noWA,
        zoom_user: zoom,
        is_main_user: location.state.is_main_user,
        package_id: location.state.packageId
    })
        .then(async function (response) {
            let obj = {
                selectedDateBorn,
                gender,
                marital,
                religion,
                province,
                districts,
                fullname,
                email,
                noWA,
                zoom,
                nik,
                address,
                kecamatan,
                kelurahan,
                postalCode,
                participantId: response.data.item.id,
                birthPlace
            }

            window.localStorage.setItem('biodata', JSON.stringify(obj));
            if (response.data.exist === true) {
                console.log(location.state)
                if (location.state.is_main_user === false) {
                    console.log('masuk ke false')
                    console.log(location.state)
                    let getParticipant = await axios.post(`${process.env.REACT_APP_API}/participant/check`, { email })
                    return history.push({
                        pathname: '/biodata/education',
                        state: {
                            countParticipant: location.state.countParticipant,
                            exist: response.data.exist,
                            is_main_user: location.state.is_main_user,
                            getParticipant: getParticipant.data,
                            getPayment: location.state.getPayment,
                            payment_id: location.state.getPayment.id
                        }
                    })
                }
                return history.push({
                    pathname: '/biodata/education',
                    state: {
                        countParticipant: location.state.countParticipant,
                        exist: response.data.exist,
                        is_main_user: location.state.is_main_user,
                        getParticipant: location.state.getParticipant,
                        getPayment: location.state.getPayment,
                        payment_id: location.state.getPayment.id
                    }
                })
            }

            if (location.state.is_main_user === true) {
                return history.push({
                    pathname: '/biodata/education',
                    state: {
                        countParticipant: location.state.countParticipant,
                        exist: response.data.exist,
                        payment_id: response.data.payment_id,
                        is_main_user: location.state.is_main_user
                    }
                })
            } else {
                return history.push({
                    pathname: '/biodata/education',
                    state: {
                        countParticipant: location.state.countParticipant,
                        exist: response.data.exist,
                        payment_id: location.state.payment_id,
                        is_main_user: location.state.is_main_user
                    }
                })
            }
        })
        .catch(function (error) {
            return Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: error
            })
        })
}